import { action, observable, runInAction, makeObservable } from "mobx";
import NpsInformerApi from "../api/NpsInformerApi";

import PopupElement from "./models/PopupElement";

class Nps {
  constructor(rootStore) {
    makeObservable(this, {
      show: observable,
      screen: observable,
      ratingValue: observable,
      isWait: observable,
      isError: observable,
      isSendPoint: observable,
      alreadyVoited: observable,
      onSwitch: action,
      sendAnswer: action,
      showNps: action,
      close: action,
    });

    this.rootStore = rootStore;
    this.NpsInformerApi = new NpsInformerApi();

    this.npsPopup = new PopupElement({
      name: "nps",
      eventType: "internal",
      priority: "important",
      position: "bottomRight",
      openCallback: this.showNps,
      custom: true,
    });
  }

  /** Показываем ли информер */
  show = false;

  /** Какой сейчас экран ("rating", "answer" или "result") */
  screen = "rating";

  /** Выбранная оценка */
  ratingValue = 0;

  /** Ждём ли ответ */
  isWait = false;

  /** Отправили ли оценку */
  isError = false;

  /** Отправили ли комментарий */
  isSendPoint = false;

  /** Уже голосовал */
  alreadyVoited = false;

  initNps = () => {
    if (window.innerWidth > 1023) {
      this.checkIsParticipant();
    }
  };

  checkIsParticipant = (isSwitch) => {
    this.NpsInformerApi.getIsParticipant()
      .then(({ data }) => {
        if (data && isSwitch) {
          runInAction(() => {
            this.screen = "answer";
            this.isWait = false;
          });
        }

        if (data && !isSwitch) {
          this.rootStore.popupController.addPopupToQueue(this.npsPopup);
        }

        if (!data) {
          runInAction(() => {
            this.screen = "result";
            this.isWait = false;
            this.alreadyVoited = true;
          });
        }
      })
      .catch(() => {
        if (isSwitch) {
          runInAction(() => {
            this.isError = true;
            this.isWait = false;
          });
        }
      });
  };

  /** Отправить оценку */
  sendPoint = () => {
    // Мы уже отправили оценку, не надо больше
    if (this.isSendPoint) {
      return;
    }

    this.NpsInformerApi.sendPoint(this.ratingValue)
      .then(() => {
        runInAction(() => {
          this.isSendPoint = true;

          if (this.isSendAnswer && this.screen === "answer") {
            this.onSwitch();
          }
        });
      })
      .catch(() => {
        runInAction(() => {
          this.isError = true;
        });
      });
  };

  /** Обработчик смены экрана */
  onSwitch = (rating) => {
    if (this.screen === "rating") {
      this.isWait = true;
      this.ratingValue = rating;
      this.isError = false;

      this.checkIsParticipant(true);
    }

    if (this.screen === "answer") {
      this.screen = "result";
    }
  };

  /** Отправить текст комментария по кнопке Отправить */
  sendAnswer = (text) => {
    if (this.isSendAnswer) {
      return;
    }

    this.isWait = true;

    this.NpsInformerApi.sendAnswer(text)
      .then(() => {
        runInAction(() => {
          this.isSendAnswer = true;
          this.isWait = false;
        });

        if (this.isSendPoint) {
          this.onSwitch();
        }
      })
      .catch(() => {
        runInAction(() => {
          this.isError = true;
          this.isWait = false;
        });
      });
  };

  showNps = () => {
    this.show = true;
  };

  close = () => {
    this.show = false;
    this.rootStore.popupController.handlePopupClose(this.npsPopup);
  };

  /** Отказаться от опроса (На экране rating нажать крестик) */
  sendReject = () => {
    this.NpsInformerApi.sendReject()
      .then(() => undefined)
      .catch(() => undefined);
  };

  /** Обработчик на бальном круге 🔵, который выбрали */
  onClick = (rating) => {
    if (this.screen === "rating") {
      this.onSwitch(rating);
    }
  };

  /** Обработчик закрытия информера */
  onClose = () => {
    if (this.screen === "rating") {
      this.sendReject();
    }

    if (this.screen === "answer") {
      this.sendPoint();
    }

    this.close();
  };

  /** Обработчик нажатия на кнопку Отправить */
  onAnswer = (text) => {
    this.sendAnswer(text);
    this.sendPoint();
  };
}

export default Nps;
